import React, { ImgHTMLAttributes, useState } from "react";

interface Props extends ImgHTMLAttributes<any> {
  fallback: string;
  failedImageHandler: any;
}

export default function ImageWithFallback({
  fallback,
  failedImageHandler,
  src,
  ...props
}: Props) {
  const [imgSrc, setImgSrc] = useState<string | undefined>(src);
  let failedImages: any[] = [];
  const onError = (errImg: any) => {
    setImgSrc(fallback);

    if (!failedImages.includes(errImg)) {
      failedImages.push(errImg);
    }

    failedImageHandler(failedImages);
  };

  return (
    <img
      className="round-image"
      src={src ? src : fallback}
      onError={() => onError(imgSrc)}
      {...props}
    />
  );
}
